import { NgModule } from '@angular/core';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { NgChartsModule } from 'ng2-charts';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [],
  imports: [
    GalleryModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    PdfViewerModule,
    NgChartsModule,
  ],
  exports: [GalleryModule, ToastrModule, PdfViewerModule, NgChartsModule],
})
export class ExternalModule {}
